module.exports = __webpack_public_path__ + "img/barcelo-pool-4.23ae140e.jpg";